module.exports = __webpack_public_path__ + "static/media/11_profile_picture.348b3263.png";